import { createSlice } from '@reduxjs/toolkit';

import { handleGetAdminSupplementInquiryStatuses } from './actions';
import { IAdminSupplementInquiryStatusesState } from './slice.interface';

const initialState: IAdminSupplementInquiryStatusesState = {
  data: [],
  isLoading: false,
  isReady: false,
  error: false,
};

export const adminSupplementInquiryStatusesSlice = createSlice({
  name: 'admin-supplement-inquiry-statuses',
  initialState,
  reducers: {
    removeAdminSupplementInquiryStatuses: (state: IAdminSupplementInquiryStatusesState) => {
      state.data = [];
      state.isLoading = false;
      state.isReady = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(
        handleGetAdminSupplementInquiryStatuses.pending,
        (state: IAdminSupplementInquiryStatusesState) => {
          state.isLoading = true;
          state.error = false;
        },
      )
      .addCase(
        handleGetAdminSupplementInquiryStatuses.rejected,
        (state: IAdminSupplementInquiryStatusesState) => {
          state.isLoading = false;
          state.error = true;
        },
      )
      .addCase(
        handleGetAdminSupplementInquiryStatuses.fulfilled,
        (state: IAdminSupplementInquiryStatusesState, action) => {
          state.data = action.payload.data;
          state.isLoading = false;
          state.isReady = true;
        },
      );
  },
});

export const { removeAdminSupplementInquiryStatuses } = adminSupplementInquiryStatusesSlice.actions;

export default adminSupplementInquiryStatusesSlice.reducer;
